(function () {
  function initStickyATCInstance(stickyBar) {
    if (stickyBar.dataset.initialized === 'true') return;

    var sectionId = stickyBar.dataset.sectionId;
    var mainProduct = document.getElementById('MainProduct-' + sectionId);
    if (!mainProduct) return;

    var stickyButton = stickyBar.querySelector('[data-sticky-atc-button]');
    var stickyLabel = stickyBar.querySelector('[data-sticky-atc-label]');
    if (!stickyButton || !stickyLabel) return;

    function getOriginalButton() {
      return (
        document.querySelector('#product-form-' + sectionId + ' button[type="submit"]') ||
        mainProduct.querySelector('product-form button[type="submit"]') ||
        mainProduct.querySelector('form[action*="/cart/add"] button[type="submit"]') ||
        mainProduct.querySelector('button[name="add"]') ||
        mainProduct.querySelector('[type="submit"][name="add"]')
      );
    }

    var originalButton = getOriginalButton();

    if (!originalButton) {
      setTimeout(function () {
        initStickyATCInstance(stickyBar);
      }, 500);
      return;
    }

    stickyBar.dataset.initialized = 'true';

    function syncButton() {
      originalButton = getOriginalButton() || originalButton;

      var labelSource = originalButton.querySelector('span') || originalButton;
      var label = (labelSource.textContent || '').replace(/\s+/g, ' ').trim() || 'Add to cart';
      stickyLabel.textContent = label;

      var disabled =
        originalButton.disabled ||
        originalButton.getAttribute('aria-disabled') === 'true';
      stickyButton.disabled = disabled;
    }

    function setVisible(visible) {
      stickyBar.classList.toggle('is-visible', visible);
      stickyBar.setAttribute('aria-hidden', visible ? 'false' : 'true');
    }

    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var shouldShow = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
      setVisible(shouldShow);
    }, { threshold: 0 });

    io.observe(originalButton);

    var mo = new MutationObserver(syncButton);
    mo.observe(originalButton, {
      attributes: true,
      attributeFilter: ['disabled', 'aria-disabled']
    });

    stickyButton.addEventListener('click', function () {
      originalButton = getOriginalButton() || originalButton;
      if (!originalButton || originalButton.disabled) return;
      originalButton.click();
    });

    syncButton();
  }

  function initAll() {
    document.querySelectorAll('.sticky-atc[data-section-id]').forEach(initStickyATCInstance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
